import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import TablePreviewXLSX from './TablePreviewXLSX';
import { useTranslation } from 'react-i18next';
import FormFileXlsx from './FormFileXlsx';

const useStyles = makeStyles(({
  container: {
    padding: '40px'
  },
  containerTable: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '16px'
  }
}));

function extractPlaceholders (text) {
  const placeholders = [];
  const regex = /{{\{?metadata\.meta\.(\w+)\}?\}}/g;

  let match;
  while ((match = regex.exec(text)) !== null) {
    placeholders.push(match[1]);
  }

  return placeholders;
}

const StepUploadFileData = ({ data, onChange, setIsValid }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [excelData, setExcelData] = useState(data.step2 && data.step2.oldExcelData ? data.step2.oldExcelData : null);

  const { template, templateId } = data.step1;
  const headersTable = excelData ? Object.keys(excelData[0]) : [];

  let variable;
  if (templateId) {
    variable = template && template.content ? extractPlaceholders(template.content) : null;
  }

  setIsValid(excelData !== null);

  return (
    <div className={classes.container}>
      <FormFileXlsx
        notificationType={data.step1.type}
        variable={variable}
        onChange={onChange}
        setExcelData={setExcelData} />
      <div className={classes.containerTable}>
        {excelData ? (
          <TablePreviewXLSX headers={headersTable} rows={excelData} />
        ) : (
          <Typography align='center' variant='caption'>{t('wizardBulkNotification:noFileSelected')}</Typography>
        )}
      </div>
    </div>
  );
};

StepUploadFileData.propTypes = {
  onChange: PropTypes.func.isRequired,
  setIsValid: PropTypes.func.isRequired,
  data: PropTypes.object
};

export default StepUploadFileData;
